// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".businessSelected{border:3px solid #4a669e!important;color:#4a669e!important}", ""]);
// Exports
module.exports = exports;
